import { useEffect, useState } from "react";
import { secondAxios } from "../api/axios";
import { useAuthContext } from "../context/authContext";

/**
 * Fetches the plants/projects visible to the current user's client —
 * same visibility rule used by the main Projects table (admin client sees
 * everything, everyone else is filtered to their own client).
 */
export default function useClientPlants() {
  const { user } = useAuthContext();
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.client) {
      setLoading(false);
      return;
    }

    let cancelled = false;

    const fetchPlants = async () => {
      try {
        setLoading(true);
        const res = await secondAxios.get("/plant");
        const adminClient = process.env.REACT_APP_CLIENT_NAME;
        const data = Array.isArray(res.data) ? res.data : [];

        const filtered =
          user.client === adminClient
            ? data
            : data.filter((plant) => {
                const clientName = plant.client?.name;
                const clientPrefix = plant.client?.prefix;
                return (
                  clientName === user.client || clientPrefix === user.client
                );
              });

        if (!cancelled) setPlants(filtered);
      } catch (err) {
        console.error("Error fetching plants:", err);
        if (!cancelled) setPlants([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchPlants();

    return () => {
      cancelled = true;
    };
  }, [user?.client]);

  return { plants, loading };
}
